import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/mizuni': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111.1 248 248 0 137-111 248-248 248s-248-111-248-248c0-136.9 111-248 248-248zM168 359.9v-223.9c0-22.1-17.9-40-40-40s-40 17.9-40 40v272.1c21.2-20.9 48.6-37.6 80-48.2zM288 350v-214c0-22.1-17.9-40-40-40s-40 17.9-40 40v214c13-2 26.4-3.1 40.2-3.1 13.6 0 26.9 1.1 39.8 3.1zM408 407.7v-271.7c0-22.1-17.9-40-40-40s-40 17.9-40 40v223.7c31.4 10.6 58.8 27.2 80 48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/mizuni.js
// module id = 939
// module chunks = 0